import { IncomingHttpHeaders } from 'http'
import { defineStore } from 'pinia'
import { StoreId } from '~/store'
import { AppState, SnackbarType, SnackbarLocation } from '~/store/app/app.types'

export const useAppStore = defineStore({
  id: StoreId.APP,
  state: (): AppState => ({
    snackbar: {
      type: SnackbarType.MESSAGE,
      message: '',
      show: false,
      location: SnackbarLocation.TOP,
    },
    isWebview: false,
    isVisibleApplicationBanner: false,
  }),
  actions: {
    showSnackbar({
      message,
      type,
      location,
    }: {
      message: string
      type?: SnackbarType
      location?: SnackbarLocation
    }) {
      if (!this.snackbar.show) {
        this.snackbar = {
          show: true,
          message,
          type: type || SnackbarType.MESSAGE,
          location: location || SnackbarLocation.TOP,
        }

        return
      }

      this.snackbar.show = false

      this.snackbar = {
        ...this.snackbar,
        message,
        type: type || SnackbarType.MESSAGE,
      }
    },
    hideSnackbar() {
      this.snackbar.show = false
    },

    // мутация для определения по заголовкам, является приложение webview или нет
    // в приложении добавляется заголовок `platform` со значением `Android/iOS`
    detectWebview(headers: IncomingHttpHeaders | undefined) {
      if (!headers) {
        this.isWebview = false

        return
      }

      const webviewHeaderName = 'platform'
      const webViewHeaderPossibleValues = new Set(['android', 'ios'])
      const value = headers[webviewHeaderName]

      // если значение заголовока - стринга и входит в список известных нам значений -> это webview
      if (typeof value !== 'string') return
      const lowercase = value
        .split('')
        .map((c) => c.toLowerCase())
        .join('')
      this.isWebview = webViewHeaderPossibleValues.has(lowercase)
    },

    setVisibleApplicationBanner(isVisibleApplicationBanner: boolean) {
      this.isVisibleApplicationBanner = isVisibleApplicationBanner
    },
  },
})
